// extracted by mini-css-extract-plugin
export default {"resendEmail":"Fz2jnXbMPAznAEB6fGLM"};